import {TweenMax, Linear} from 'gsap';
import AbstractView = require("./abstract/AbstractView");


class LoadingView extends AbstractView {

    constructor(id: number, selector: JQuery) {
        super(-1, selector);
        this.init()
    }

    private progress: JQuery;
    private percentText: JQuery;

    public init(): void {
        this.progress = this.getChildBySelector(".progress");
        this.percentText = this.progress.find(".percent");
    }

    public onProgress(percent: number): void {
        this.percentText.html(percent.toString() + "%");
    }

    public reset(): void {
        this.percentText.html("0");
    }


    transitionIn(): void {
    }

    transitionOut(): void {
        TweenMax.killTweensOf(this);
        TweenMax.to(this.$template, 1, {
            delay: 0.5,
            alpha: 0,
            ease: Linear.easeOut,
            onComplete: () => {
                this.$template.css("display", "none");
            },
            onCompleteParams: ["OUT_COMPLETED"]
        });
    }
}

export = LoadingView;